$(document).ready(function () {
    $('#agree-checkbox').change(function() {
        checkEnableBtnRegisterEmail();
    });

    function checkEnableBtnRegisterEmail() {
        if ($('#agree-checkbox').is(':checked')) {
            $('#btn-register-email').prop('disabled', false);
        } else {
            $('#btn-register-email').prop('disabled', true);
        }
    }
});
